import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a1a97cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "vendor-card",
  class: "tw-bg-[#FCFCFC] tw-h-[119px] tw-w-[100%] tw-border tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
}
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-h-full tw-justify-between" }
const _hoisted_3 = { class: "tw-flex align-items-end" }
const _hoisted_4 = { class: "detail-info" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-not-italic" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-items-center tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-not-italic" }
const _hoisted_7 = { class: "tw-w-[85px]" }
const _hoisted_8 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[50%] tw-h-[16px]"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-text-[#231F20] tw-text-[13px] tw-overflow-hidden tw-flex-1"
}
const _hoisted_10 = {
  id: "vendor-card-name",
  class: "vendor-name",
  "data-cy": "vendor-name"
}
const _hoisted_11 = { class: "tw-flex tw-justify-between tw-items-center tw-font-[500] tw-my-[11px]" }
const _hoisted_12 = { class: "tw-w-[85px]" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[50%] tw-h-[16px]"
}
const _hoisted_14 = {
  key: 1,
  class: "tw-overflow-hidden tw-flex-1"
}
const _hoisted_15 = { class: "tw-flex tw-justify-between tw-items-center tw-font-[500]" }
const _hoisted_16 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[50%] tw-h-[16px]"
}

import { getComponentUiText, getNextDay } from "@/utils/utilities";
import { getLocale } from "@/utils/dateTimeUtils";
import dayjs from "dayjs";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorCard',
  props: {
  vendor: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const isHoverExpiryDate = ref(false);
const isHover = ref(false);

const recipientName = computed(() => {
  const recipientNameArr: string[] = [
    props.vendor.recipientFirstName,
    props.vendor.recipientLastName,
  ];
  const recipientNameArrFilter = recipientNameArr.filter(Boolean);
  const result = recipientNameArrFilter.length
    ? recipientNameArrFilter.join(" ")
    : "-";
  return result;
});

const getCurrentTime = () => {
  if (!props.vendor.expiryDate) return "-";
  return isHoverExpiryDate.value
    ? dayjs(props.vendor.expiryDate).locale(getLocale()).format("DD MMM YYYY")
    : getNextDay(new Date(props.vendor.expiryDate));
};

const onHoverRecipient = () => {
  if (recipientName.value === "-") return;
  isHover.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessments-vendor-card-title-1",
                  )), 1),
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(__props.vendor?.name || "-"), 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessments-vendor-card-recipient-tag-1",
                  )), 1),
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", {
                      id: "vendor-card-email",
                      class: "tw-text-[#878787] tw-font-[400] vendor-email",
                      "data-cy": "recipient-email",
                      onMouseover: onHoverRecipient,
                      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = false))
                    }, _toDisplayString(isHover.value ? recipientName.value : __props.vendor?.recipient || "-"), 33)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-vendor-card-expiry-date-tag-1",
                )) + " ", 1),
              (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    id: "vendor-card-expiry-date",
                    class: "tw-text-[#878787] tw-font-[400] tw-cursor-pointer",
                    "data-cy": "expiry-date",
                    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHoverExpiryDate.value = true)),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHoverExpiryDate.value = false))
                  }, _toDisplayString(getCurrentTime()), 33))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})